import {
  IconSearch,
  IconFile,
  IconTerminal,
  IconFolder,
  IconPencil,
  IconCpu,
  IconGlobe,
} from './ToolIcons'

export type IconFC = React.FC<{ className?: string }>

export const TOOL_CONFIGS: Record<string, { Icon: IconFC; color: string }> = {
  grep:         { Icon: IconSearch,   color: 'text-white/60' },
  glob:         { Icon: IconFolder,   color: 'text-white/60' },
  read:         { Icon: IconFile,     color: 'text-white/60' },
  bash:         { Icon: IconTerminal, color: 'text-white/60' },
  write:        { Icon: IconPencil,   color: 'text-white/60' },
  edit:         { Icon: IconPencil,   color: 'text-white/60' },
  notebookedit: { Icon: IconPencil,   color: 'text-white/60' },
  task:         { Icon: IconCpu,      color: 'text-white/60' },
  webfetch:     { Icon: IconGlobe,    color: 'text-white/60' },
  websearch:    { Icon: IconGlobe,    color: 'text-white/60' },
}

export const SKIP_KEYS = new Set(['session', 'block', 'dangerouslyDisableSandbox'])
